import React from 'react'
import CIcon from '@coreui/icons-react'
import { cilBell, cilCalculator, cilCalendar, cilChartPie, cilCursor, cilDescription, cilDrop, cilLevelUp, cilNotes, cilPencil, cilPuzzle, cilSpeedometer, cilStar, cilUser, } from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'

const VendorSideBarNav = [
    // {
    //     component: CNavTitle,
    //     name: '매출통계',
    // },
    // {
    //     component: CNavItem,
    //     name: '매출통계',
    //     to: '/vendor/sales',
    //     icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
    // },
    // {
    //     component: CNavTitle,
    //     name: '재고관리',
    // },
    // {
    //     component: CNavItem,
    //     name: '재고관리',
    //     to: '/vendor/inventory',
    //     icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
    // },
    // {
    //     component: CNavTitle,
    //     name: '발주요청',
    // },
    // {
    //     component: CNavItem,
    //     name: '상품발주요청',
    //     to: '/vendor/orderRequest',
    //     icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
    // },
    {
        component: CNavTitle,
        name: '정산',
    },
    {
        component: CNavItem,
        name: '정산관리',
        to: '/vendor/settlement',
        icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
    },
    {
        component: CNavItem,
        name: '매출통계',
        to: '/vendor/salesStatistics',
        icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
    },
    {
        component: CNavTitle,
        name: '매장',
    },
    {
        component: CNavItem,
        name: '매장관리',
        to: '/vendor/storeManagement',
        icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
    },

]

export default VendorSideBarNav;
